import React from 'react';
import BaseModal from 'Modals/BaseModal';
import ModalTypeEnum from 'Modals/ModalConstants';
import connectModal from 'Modals/enhancers/ConnectModal';
import withAnimation from 'Modals/enhancers/AnimateModal';


const defaultLoadSteps = [
  {
    percent: 10,
    interval: 100,
    content: {},
  },
  {
    percent: 90,
    interval: 1000,
    content: {},
  },
];

const FreeWriteDocumentUploadModalLoadingContainer = connectModal(
  withAnimation(BaseModal, true),
  'freewriteUploadLoadingModal',
  {
    modalType: ModalTypeEnum.FREE_WRITE_UPLOAD_LOADING,
    loadOptions: {
      loadingBarContent: (
        <div>
          <div className="freewrite-upload-message">Uploading Your PDF...</div>
        </div>
      ),
      loadSteps: defaultLoadSteps,
      isDynamicContent: true,
      loadingBarClasses: 'progress-success',
      loadingModalBodyClasses: 'modal-body freewrite-upload-modal',
    },
    includeHeaderCloseButton: true,
  },
);

export default FreeWriteDocumentUploadModalLoadingContainer;



// WEBPACK FOOTER //
// ./src-react/Modals/containers/FreeWriteDocumentUploadLoadingModal/index.jsx